module.exports = __webpack_public_path__ + "static/android-screenshot-f7a4b92b644f16f227948d69da4596b8.jpg";